module.exports = __webpack_public_path__ + "static/media/pustack_app_logo.19544ac5.svg";